import { render } from "./saleChart.vue?vue&type=template&id=16a04f37"
import script from "./saleChart.vue?vue&type=script&lang=js"
export * from "./saleChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__